import type { FaireProductEntity } from "../../entity_types/product";

export const p_nddbma222u: FaireProductEntity = {
  token: "p_nddbma222u",
  type: "product",
  name: "Tennis necklace and bracelet set with pink cubic zirconia, 18K PVD gold‑plated steel",
  brandToken: "b_3t5pew5dxb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/41ac8f261d2be353ddbbfbc3b08f4805d0797dac8d7866fefc857a07a827f824.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34f18a312f97d669e9896b5939307477c24698a42c2052450f3fa38130b76dcf.jpeg",
    "https://cdn.faire.com/fastly/75c262913912b630a9385c8d9a93b70af5fa0527b5d60cc5cd4d966eb9fa0501.jpeg",
    "https://cdn.faire.com/fastly/454ce8ab4a0473721fdf4c039f785243a7ecee57270a4f23fc9d4ffa337e3c74.jpeg",
    "https://cdn.faire.com/fastly/f5c498ae04a68c44d0a1b64c0ef7a8ba3c74e4e4ef7a0121176015ed838a199f.jpeg",
  ],
  priceDollars: 22.36,
  description:
    "The price includes a necklace and a bracelet as a set\n\nPremium Material: Stainless steel with 18K vacuum gold plating (PVD waterproof); water-resistant, durable and does not fade.\nFinish: Polished with cubic zirconia\nHypoallergenic: Safe for sensitive skin; does not stain or irritate.\nNecklace length: approximately 45 cm plus 5 cm extension, adjustable\nBracelet length: approximately 21 cm with extension for wrists from approximately 14 cm to 19 cm\n\nStock in Spain: Fast shipping and no customs.\n\nDirect Price: Luxury aesthetics at factory price.",
  tags: [],
  msrpDollars: 44.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:08.613Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
